const hasAccess = (route, userRole) => {
    if (!route.roles || route.roles.length === 0) {
        return true;
    }
    return route.roles.includes(userRole);
};

export { hasAccess };
